module.exports = __webpack_public_path__ + "img/shield.9aeb49f3.png";